// extracted by mini-css-extract-plugin
export default {"loading-box":"LoadingBox_loading-box__5rbUO","loading-center":"LoadingBox_loading-center__NE-at","loading-info":"LoadingBox_loading-info__3eTGJ"};